﻿import { ajaxGet, ajaxPost, ajaxPostWithJSON } from '../utils/ajax';
import { getQueryString } from '../../../js/shared/utils/ajax.js';

const addToCartUrl = '/teliadk/api/cart/addtocart';
const getBasketUrl = '/teliadk/api/cart/getcartdetails';
const getTotalOfferingPriceUrl = '/teliadk/api/cart/gettotalofferingprice';

export default {
    addToBasket(data, callback, errorCallback) {        
        if (data.product.productcode && data.product.variant && data.address && Object.keys(data.address).length) {
            const parameters = {
                'installationFeeCode': data.installationFeeCode,
                'activationFeeCode': data.activationFeeCode,
                'paymentFeeCode': data.paymentFeeCode,
                'speedUp': data.product.speedUp,
                'speedDownload': data.product.speedDown,
                'productcode': data.product.productcode,
                'variantcode': data.product.variant,
                'additionalvariantcodes': data.product.additionalvariantcodes || [],
                'numberofvas': data.product.numberofvas,
                'address.streetName': data.address.streetName,
                'address.streetNumber': data.address.streetNumber,
                'address.floorNumber': data.address.floorNumber,
                'address.floorSide': data.address.floorSide,
                'address.postCode': data.address.postCode,
                'address.city': data.address.city,
                'isBoost': data.product.isBoost,
                'vendor': data.product.vendor,
            };

            ajaxPost(addToCartUrl, parameters)
                .then(callback)
                .catch(errorCallback);
        }
    },
    getBasket(blockid, callback, errorCallback) {
    	var requestUrl = getBasketUrl + '/' + blockid;

    	var orderRef = getQueryString('oref');
    	if(orderRef){
    		requestUrl += '?oref=' + orderRef;
    	}

    	ajaxGet(requestUrl, true)
            .then(callback)
            .catch(errorCallback);
    },
    getTotalOfferingPrice(productCode, serviceCodes, blockId, callback, errorCallback) {
        let codes = [];
        if (productCode) {
            codes.push(productCode);
            for (let i = 0; i < serviceCodes.length; i++) {
                codes.push(serviceCodes[i].code);
            }
        }

        const parameters = {
            'blockId': blockId,
            'productCodes': codes
        }

        ajaxPostWithJSON(getTotalOfferingPriceUrl, parameters, true)
            .then(callback)
            .catch(errorCallback);

    }
}
